// OrdenServicio.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseFetchEnabledParams, UseMutationsParams, UseUpdateParams } from "@/shared/interfaces";
import { urlBackend } from "@/shared/constants";
import { erpApi } from "@/shared/axios";
import { getUrlParamsFetch } from "@/shared/utils";
import { toApiError } from "@/shared/utils/general";
import { OrdenServicio, OrdenServicioForm, OrdenServicioPagingResp, OrdenServicioParams } from '@/erp/orden-servicio/orden-servicio';

const { get, post, put } = erpApi();

// get

export const useFetchGetOrdenServicio = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<OrdenServicioParams> = {}) => {
  return useQuery({
    queryKey: ['orden-servicio', ...Object.values(params ?? {})],
    queryFn: () => getOrdenServicio(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getOrdenServicio = async (
  params?: OrdenServicioParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<OrdenServicioPagingResp>(`${urlBackend}api/v1/orden-servicio?${queryParams}`, true);
};

// create

export const useFetchPostOrdenServicio = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: OrdenServicioForm) => {
      return postOrdenServicio(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['orden-servicio']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postOrdenServicio = async (data: OrdenServicioForm) => {
  return await post<OrdenServicio>(`${urlBackend}api/v1/orden-servicio`, data, true);
};

// filter by id

export const useFetchGetByIdOrdenServicio = (id: string) => {
  return useQuery({
    queryKey: ['orden-servicio', id],
    queryFn: async () => {
      return getByIdOrdenServicio(id);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdOrdenServicio = async (id: string) => {
  const res = await get<OrdenServicio>(`${urlBackend}api/v1/orden-servicio/${id}`, true);
  return res;
};

// update

export const useFetchPutOrdenServicio = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: UseUpdateParams<OrdenServicioForm>) => {
      return putOrdenServicio(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ['orden-servicio']
      });
      
      navigate && returnUrl && navigate(returnUrl);

      toast.success(res.message);
    },
    onError: (error) => {
      const data = toApiError(error)
      toast.error(data.message)
    },
    onSettled: () => {

    },
  });
};

export const putOrdenServicio = async ({
  id,
  data
}: UseUpdateParams<OrdenServicioForm>) => {
  return put<OrdenServicio>(`${urlBackend}api/v1/orden-servicio/${id}`, data, true);
};
